/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Initial_TextInputs */

const en_try_magic_initial_text = /** @type {(inputs: Try_Magic_Initial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening allows you to turn anything into audio, so you can listen to it on the go. Listen while at the gym, on a walk, or while cooking dinner!

Many people find they can listen 2x, even 3x faster than they read. It's easy to get started, so give Listening a try today!`)
};

const es_try_magic_initial_text = /** @type {(inputs: Try_Magic_Initial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening te permite convertir cualquier cosa en audio, para que puedas escucharlo donde quieras. ¡Escucha mientras estás en el gimnasio, caminando o preparando la cena!

Muchas personas descubren que pueden escuchar 2x, incluso 3x más rápido de lo que leen. Es fácil empezar, ¡así que prueba Listening hoy!`)
};

/**
* | output |
* | --- |
* | "Listening allows you to turn anything into audio, so you can listen to it on the go. Listen while at the gym, on a walk, or while cooking dinner! Many people..." |
*
* @param {Try_Magic_Initial_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_initial_text = /** @type {((inputs?: Try_Magic_Initial_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Initial_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_initial_text(inputs)
	return en_try_magic_initial_text(inputs)
});